import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RevenueDashboard from './RevenueDashboard';

export default function RevenueRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RevenueDashboard />} />
    </Routes>
  );
}
